<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [user]="exercise.author"
            [mode]="'avatar'"
          ></ngx-view-user-display>
        </div>

        <div>
          <ngx-view-user-display
            [user]="exercise.author"
            [mode]="'name'"
          ></ngx-view-user-display>
          <ngx-view-time-ago
            [currentDate]="exercise.createdOn"
          ></ngx-view-time-ago>

          <div *ngIf="exercise.refTitle" class="text-link">
            <nb-icon icon="globe-outline"></nb-icon>
            <a class="link" (click)="navigateRef(exercise)">
              {{
                exercise.refTitle.length < 60
                  ? exercise.refTitle
                  : exercise.refTitle.substring(0, 60) + "..."
              }}
            </a>
          </div>

          <div *ngIf="!exercise.refTitle" class="text-link">
            <nb-icon icon="hash-outline"></nb-icon>
            <ngx-view-tags
              [tags]="exercise.tags"
              (onTagSelected)="tagSelected($event)"
            ></ngx-view-tags>
          </div>

          <div *ngIf="exercise.createdBy == uid">
            <button
              nbButton
              ghost
              size="tiny"
              [status]="
                exercise.status == 1
                  ? 'success'
                  : exercise.status == -1
                  ? 'warning'
                  : 'info'
              "
              (click)="edit(exercise)"
            >
              <nb-icon
                [icon]="
                  exercise.status == 1 ? 'eye-outline' : 'eye-off-outline'
                "
              ></nb-icon>
              <span>{{
                exercise.status == 1
                  ? "Xuất bản"
                  : exercise.status == -1
                  ? "Ẩn nội dung"
                  : "Đang thực hiện"
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <ngx-button-bookmark *ngIf="mode == 'detail'" [exercise]="exercise">
      </ngx-button-bookmark>

      <button
        nbButton
        ghost
        shape="round"
        status="primary"
        size="small"
        class="action-button"
        [disabled]="loading"
        [class.btn-pulse]="loading"
        [nbContextMenu]="menuItems"
        [nbContextMenuTag]="'action-buttons-' + exercise.id"
        (click)="loadButtonAction(exercise)"
      >
        <nb-icon icon="more-horizontal-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body *ngIf="mode != 'detail'">
    <h6 class="text-heading">{{ exercise.title }}</h6>

    <nb-card>
      <nb-card-body>
        <div class="row">
          <div class="col-12 col-sm-6">
            <ngx-view-exercise-detail [exercise]="exercise">
            </ngx-view-exercise-detail>
          </div>

          <div class="col-12 col-sm-6">
            <nb-card class="card-detail">
              <nb-card-header> Top người tham gia xuất sắc </nb-card-header>
              <nb-card-body
                *ngIf="
                  exercise.exerciseUsers && exercise.exerciseUsers.length > 0
                "
              >
                <div class="row">
                  <div
                    *ngFor="let item of exercise.exerciseUsers; let i = index"
                    class="col-12"
                  >
                    <ngx-view-exercise-user-card
                      [exerciseUser]="item"
                      [mode]="'overview'"
                    ></ngx-view-exercise-user-card>
                  </div>
                </div>
              </nb-card-body>

              <nb-card-footer
                *ngIf="
                  !exercise.exerciseUsers || exercise.exerciseUsers.length == 0
                "
              >
                <button
                  nbButton
                  outline
                  status="success"
                  size="small"
                  class="action-button"
                  [disabled]="loading"
                  [class.btn-pulse]="loading"
                  (click)="doExercise()"
                >
                  <nb-icon icon="flag-outline"></nb-icon>
                  Trở thành người đầu tiên
                </button>
              </nb-card-footer>
            </nb-card>
          </div>
        </div>
      </nb-card-body>

      <nb-card-footer>
        <div class="button-play">
          <button
            nbButton
            hero
            shape="semi-round"
            status="danger"
            size="small"
            class="action-button"
            [disabled]="loading"
            [class.btn-pulse]="loading"
            (click)="doExercise()"
          >
            <nb-icon icon="play-circle-outline"></nb-icon>
            Tham gia
          </button>
        </div>
      </nb-card-footer>
    </nb-card>
  </nb-card-body>

  <nb-card-footer>
    <div class="button-actions">
      <ngx-view-like *ngIf="mode == 'detail'" [exercise]="exercise">
      </ngx-view-like>
      <button
        *ngIf="mode != 'detail'"
        nbButton
        ghost
        shape="semi-round"
        size="small"
      >
        <i class="fas fa-thumbs-up"></i>
        <span>{{ exercise.noLiked | number }} </span>
      </button>

      <button
        *ngIf="exercise.showComments"
        nbButton
        ghost
        status="info"
        size="small"
        (click)="reply()"
      >
        <nb-icon icon="message-square-outline"></nb-icon>

        <div *ngIf="!exercise.noComment || exercise.noComment == 0">
          Bình luận
        </div>

        <div *ngIf="exercise.noComment > 0" style="text-transform: lowercase">
          &nbsp;Xem <span>{{ exercise.noComment | number }} </span> bình luận
        </div>
      </button>

      <ngx-button-report-spam
        [exercise]="exercise"
        (onReport)="report($event)"
      ></ngx-button-report-spam>
    </div>

    <nb-card *ngIf="view === 'replies'" class="replies">
      <nb-card-body>
        <ngx-view-comments
          [exercise]="exercise"
          [mode]="mode"
          (onClose)="closeReply()"
        >
        </ngx-view-comments>
      </nb-card-body>
    </nb-card>
  </nb-card-footer>
</nb-card>
